import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, useTheme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import GraphqlApi from '../../../api-graphql';
import {
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  Button
} from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Form from '@rjsf/material-ui';
import LoadingCard from '../../UI/LoadingCard';
import useWindowSize from '../../../customHooks/useWindowSize';
import { useTranslation } from 'react-i18next';
import { styles } from './styles';
import { connect } from 'react-redux';

const EditIdentityForm = (props) => {
  const { getAllIdentities, identity, setEditIdentity, open, classes, config } = props;
  const [message, setMessage] = useState('');
  const [dialogLoading, setDialogLoading] = useState(false);
  const [formData, setFormData] = useState(identity);
  const windowSize = useWindowSize();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const { t, i18n } = useTranslation();
  const { schema, uiSchema } = {
    ...JSON.parse(
      config.flows.find(template =>
        template.templateId === 'onBoardingRemote').steps.find(template =>
        template.templateId === 'biometricOnBoardingStep').userForm
    )
  };
  schema.properties.email.readOnly = false;
  useEffect(() => {
    function translateSchema () {
      let keys = Object.keys(schema.properties);
      for (let i = 0; i < keys.length; i++) {
        if (keys[i] === 'gender') {
          schema.properties[keys[i]].enum[0] = i18n.exists(`form:${schema.properties[keys[i]].enum[0]}`) ? t(`form:${schema.properties[keys[i]].enum[0]}`) : schema.properties[keys[i]].enum[0];
          schema.properties[keys[i]].enum[1] = i18n.exists(`form:${schema.properties[keys[i]].enum[1]}`) ? t(`form:${schema.properties[keys[i]].enum[1]}`) : schema.properties[keys[i]].enum[1];
        }

        schema.properties[keys[i]].title = i18n.exists(`form:${schema.properties[keys[i]].title}`) ? t(`form:${schema.properties[keys[i]].title}`) : schema.properties[keys[i]].title;
      }
    }

    translateSchema();
  }, []);

  const onClose = () => {
    setEditIdentity(false);
  };

  const ObjectFieldTemplate = (props) => {
    const { title, description, properties } = props;
    return (
      <Grid container spacing={3} className={classes.formGroup}>
        {title}
        {description}
        {properties.map((element, index) => (
          <Grid
            key={index}
            item
            xs={12}
            md={4}
            style={{ marginBottom: '1rem' }}
          >
            {element.name === 'birthDate' && (
              <label id='form-root_birthDate'>birthday</label>
            )}
            {element.content}
          </Grid>
        ))}
      </Grid>
    );
  };

  const removeUndefined = (form) => {
    let newFormData = form;
    for (let key in form) {
      if (form[key] === null || form[key] === undefined) {
        delete newFormData[key];
      }
    }
    delete newFormData.flow;
    return newFormData;
  };

  const onSubmit = async (e) => {
    const { formData } = e;
    setMessage(t('identityListView:loading'));
    setDialogLoading(true);
    setFormData(removeUndefined(formData));
    GraphqlApi.updateUser(formData, formData.subgroups)
      .then(async () => {
        setMessage(t('identityListView:ready'));
        await getAllIdentities();
        setTimeout(() => {
          setDialogLoading(false);
          setEditIdentity(false);
        }, 2000);
      })
      .catch((err) => {
        if (err) {
          setMessage(t('identityListView:error'));
          setTimeout(() => {
            setDialogLoading(false);
            setEditIdentity(false);
          }, 2000);
        }
      });
  };

  return (
    <>
      <LoadingCard open={dialogLoading} loading={dialogLoading} message={message} />
      {
        formData &&
          <Dialog
            onClose={onClose}
            aria-labelledby='simple-dialog-title'
            open={open}
            maxWidth='md'
            fullWidth
            fullScreen={fullScreen}
            style={{
              maxWidth: windowSize.width < 360 && windowSize.width,
              marginTop: windowSize.width < 360 && 56
            }}
          >
            <div className='close-icon'>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </div>
            <DialogTitle id='dialog-title'>
              {t('identityFormDialog:title')}
            </DialogTitle>
            <DialogContent
              style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}
            >
              <DialogContentText id='alert-dialog-description'>
                {t('identityFormDialog:content')}
              </DialogContentText>
              <Form
                schema={schema}
                uiSchema={uiSchema}
                formData={formData}
                onSubmit={onSubmit}
                ObjectFieldTemplate={ObjectFieldTemplate}
              >
                <Button type='submit' variant='contained' className={classes.btn}>
                  {t('identityFormDialog:send')}
                </Button>
              </Form>
            </DialogContent>
          </Dialog>
      }
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    config: state.config
  };
};

EditIdentityForm.propTypes = {
  getAllIdentities: PropTypes.func.isRequired,
  identity: PropTypes.object.isRequired,
  setEditIdentity: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, null)(EditIdentityForm)
);
